// Configurações gerais do sistema
export const systemConfig = {
  name: 'Observatório RIDE-DF',
  description: 'Sistema de coleta de dados do Observatório Socioeconômico e Ambiental da RIDE-DF',
  pwa: {
    shortName: 'RIDE-DF',
    display: 'standalone',
    backgroundColor: '#ffffff'
  },
  logos: {
    main: '/images/logo_full.png',
    favicon: '/favicon.ico',
    pwa: {
      small: '/images/logo192.png',
      large: '/images/logo512.png'
    },
    partners: [
      '/images/logo_sudeco.png',
      '/images/logo_unb.png'
    ]
  },
  theme: {
    primaryColor: '#0ea5e9',
    fontFamily: 'Inter, sans-serif'
  }
};

// Configurações de API
const defaultApiBaseUrl =
  process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:5000/api';

export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || defaultApiBaseUrl,
  endpoints: {
    auth: '/auth',
    forms: '/forms'
  }
};

// Configurações específicas por formulário
export const formsConfig = {
  productiveDevelopment: {
    title: 'Desenvolvimento Produtivo',
    sections: [] // Será preenchido com as seções específicas
  },
  economicInfrastructure: {
    title: 'Infraestrutura Econômica e Urbana',
    sections: []
  }
};
